import React from 'react';
import { ArrowUpRight, FileEarmarkText } from 'react-bootstrap-icons';
import { experience } from '../../data/experience';
import resume from '../../Assets/Documents/krish-resume.pdf';
import { ExperienceMark } from '../ExperienceMark';
import { SectionNav } from '../SectionNav';
import './InteriorPages.css';
import './Career.css';

const groups = [
  { id: 'work', title: 'Work experience' },
  { id: 'research', title: 'Research & teams' },
  { id: 'education', title: 'Education' },
];

// One selected outcome per role; the original supporting text stays below it.
const roleOutcomes = {
  atlassian: { value: '≈ $160/day', label: 'wasted staging spend eliminated' },
  super: { value: '30%', label: 'less time to resolve refund disputes', highlightIndex: 0, title: 'A refund pipeline built for retries' },
  otto: { value: '20%', label: 'lower CPU usage' },
};

const latestRoleId = experience.find(item => item.category === 'work')?.id;

const Experience = ({ item }) => {
  const compact = Number(item.year) <= 2024;
  const latest = item.id === latestRoleId;
  const outcome = roleOutcomes[item.id];
  const story = item.story || (outcome?.highlightIndex !== undefined ? { title: outcome.title, text: item.highlights[outcome.highlightIndex] } : null);
  const remainingHighlights = item.highlights.filter((_, index) => index !== outcome?.highlightIndex);
  const highlights = remainingHighlights.length > 0 && <ul>{remainingHighlights.map(highlight => <li key={highlight}>{highlight}</li>)}</ul>;
  return (
    <article className={`timeline${compact ? ' timeline-compact' : ''}${latest ? ' timeline-latest' : ''}`} id={item.id} aria-labelledby={`${item.id}-title`}>
      <div className="date-content"><span className="date"><span className="month">{item.period}</span><span className="year">{item.year}</span></span></div>
      <ExperienceMark item={item} />
      <div className="timeline-content">
        <header className="experience-heading">
          <div className="experience-title-row"><h3 className="title" id={`${item.id}-title`}>{item.company}</h3>{latest && <span className="experience-latest">Latest role</span>}</div>
          <p className="role-title">{item.role}</p>
          {item.team && <p className="experience-role">{item.team}</p>}
        </header>
        <div className="description">
          <p>{item.summary}</p>
          {story && <aside className="experience-story experience-result" aria-label="Selected outcome">
            {outcome && <div className="experience-result-stat"><strong>{outcome.value}</strong><span>{outcome.label}</span></div>}
            <div className="experience-result-context"><h4>{story.title}</h4><p>{story.text}</p></div>
          </aside>}
          {compact && item.category === 'work' && highlights ? <details className="experience-details"><summary>More about my time here</summary>{highlights}</details> : highlights}
        </div>
      </div>
    </article>
  );
};

export const Career = () => (
  <section className="career-page page-section">
    <div className="container">
      <header className="page-heading">
        <div className="career-intro"><h1>Work & research</h1><p>My co-ops and research have taken me from robot fleets to Rovo's connectors and data privacy. Here's what I've worked on along the way.</p></div>
        <a className="button button-secondary career-resume" href={resume} target="_blank" rel="noreferrer"><FileEarmarkText aria-hidden="true" /><span>View my résumé <span className="career-resume-format">PDF</span></span><ArrowUpRight aria-hidden="true" /></a>
      </header>
      <div className="career-layout">
      <SectionNav items={groups} label="Career sections" className="career-index" />
      <div className="career-sections">{groups.map(group => (
        <section className={`career-group career-group-${group.id}`} id={group.id} key={group.id} aria-labelledby={`${group.id}-heading`}>
          <h2 id={`${group.id}-heading`}>{group.title}</h2>
          <div className="main-timeline">{experience.filter(item => item.category === group.id).map(item => <Experience item={item} key={item.id} />)}</div>
        </section>
      ))}</div>
      </div>
    </div>
  </section>
);
